import * as React from 'react';

const Filme = ({
  titulo,
  director,
  ano,
  duracion,
  xenero,
  pais,
  premios,
  trailer,
  sinopse,
  poster,
  extraClass,
}) => {
  return (
    <div className="filme">
      <h1>
        {titulo}
        <span>{director}</span>
      </h1>
      {poster && <img src={poster} alt={titulo} className={extraClass} />}
      <h2>
        {pais} / {ano} / {duracion} min
      </h2>
      <h3>{xenero}</h3>
      <p>{sinopse}</p>
      {premios && (
        <ul className="premios">
          {premios.map((premio) => {
            return <li key={premio}>{premio}</li>
          })}
        </ul>
      )}
      {trailer && (
        <div className="trailer">
          <a href={trailer} target="_blank" rel="noreferrer">
            <i className="fas fa-play"></i> Ver trailer
          </a>
        </div>
      )}
    </div>
  )
}

export default Filme
